import { createSlice } from '@reduxjs/toolkit';

// DEPRECATED: Auth state is now managed by Auth0 SDK
// This reducer is kept for backward compatibility but is no longer used
// Components should use useAuth0() hook directly instead of Redux state

export const getInitialState = () => ({
	isAuthenticated: false
});

export const AuthSlice = createSlice({
	name: 'auth',
	initialState: getInitialState(),
	reducers: {
		setIsAuthenticated: (state, action) => {
			// No-op: Auth state is managed by Auth0 SDK
			state.isAuthenticated = action.payload;
		}
	}
});

export const {
	setIsAuthenticated,
} = AuthSlice.actions;

export default AuthSlice.reducer;